import config from "@Config/index";
import {
  FUTURE_INTAKE_CONFIG_PAGE,
  FutureIntakeConfigMap,
  parseFutureIntakeConfig,
} from "@Pages/PropertyPage/utils/futureIntake";
import axios from "axios";
import { logger } from "helpers/logger";

// The CRM toggles change rarely, so each server process keeps the last good
// answer for a few minutes instead of calling s.base on every SSR.
const CACHE_TTL_MS = 5 * 60 * 1000;
const REQUEST_TIMEOUT_MS = 1500;

let serverCache: { value: FutureIntakeConfigMap; fetchedAt: number } | null = null;

/**
 * Reads the Apply for Fall / Spring experiment toggles. Never throws: on any
 * failure it returns null, and the strip stays hidden (fail closed).
 */
const fetchFutureIntakeConfig = async (): Promise<FutureIntakeConfigMap | null> => {
  if (__SERVER__ && serverCache && Date.now() - serverCache.fetchedAt < CACHE_TTL_MS) {
    return serverCache.value;
  }
  try {
    const res = await axios.get(
      // cache=false: the public read is otherwise served from CloudFront for up to
      // ~80 minutes, so CRM changes would lag; the process cache above limits load.
      `${config.API_URL}/api/v0/application_config?page=${FUTURE_INTAKE_CONFIG_PAGE}&cache=false`,
      { timeout: REQUEST_TIMEOUT_MS },
    );
    const value = parseFutureIntakeConfig(res?.data?.data?.result);
    if (__SERVER__) serverCache = { value, fetchedAt: Date.now() };
    return value;
  } catch (error) {
    logger.error("Error fetching future intake config:", error);
    return null;
  }
};

export default fetchFutureIntakeConfig;
